// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"615":"c11801cb","688":"692c9078"}[chunkId] || chunkId) + "." + {"615":"04b4eb1b02635854","617":"73baac40c5c8e52f","688":"f6982cdcc099d8b4"}[chunkId] + ".js";
};